import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import "./style/style.css";
import "./style/Navbar.css";
import "./style/Footer.css";
import "./style/App.css";
import "./style/Home.css";
import "./style/Pre.css";
import "./style/About.css";
import "./style/FileDropUpload.css";
import "./style/FoodImageClassify.css";
import App from "./pages/App";

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
